.getResearchExperienceHeader :global(.resource-page-title)::after {
  display: none;
}

.getResearchExperienceSectionTitle {
  margin-top: 0;
  margin-bottom: var(--space-6);
  padding: 0.85rem 1rem;
  border-left: 4px solid #0b4cff;
  border-radius: 0 8px 8px 0;
  background: #f5f7ff;

  font-size: 1rem;
  font-weight: 500;
  line-height: 1.55;
  color: #24345c;
}
